import type {Organization} from "../../../data/models/Organization";
import type {AppState} from "../../../data/state/AppState";

export const switchOrganization = (org: Organization, appState: AppState, onAfterNavigate?: () => void) => {
	navigateToNewOrg(org.id, appState);
	onAfterNavigate?.();
};

export const navigateToNewOrg = (newOrgId: string, appState: AppState) => {
	appState.app.navigation.goApp({
		mainNav: appState.defaultMenu,
		organizationId: newOrgId,
	});
};
